import { inject, Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from "ngx-toastr";
import { UsersService } from "./users.service";
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class HTTPErrorInterceptor implements HttpInterceptor {
  protected toastr: ToastrService;
  protected usersService: UsersService;
  protected translate: TranslateService = inject(TranslateService);

  constructor(protected injector: Injector) {
    this.toastr = injector.get(ToastrService);
    this.usersService = injector.get(UsersService);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].indexOf(err.status) >= 0) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        this.usersService.logout();
        return;
      }
      err = err.error;

      if (!err)
        return throwError("");

      if (err.errors)
        for (const i in err.errors)//automatic model validation (user create for example)
          if (err.errors[i].length)
            this.toastr.error(this.translate.instant(err.errors[i][1] || err.errors[i][0]));

      if (err.length) {
        for (const error of err)
          if (error.errorMessage)
            this.toastr.error(this.translate.instant(error.errorMessage));
      }
      else
        if (err.Error)
          this.toastr.error(this.translate.instant(err.Error));

      if (err.ErrorMessage)
        this.toastr.error(this.translateInstantWithArgs(err.ErrorMessage, err.Args));
    }))
  }

  private formatString(text: string, args: any[]): string {
    if (!args || args.length === 0) {
      return text;
    }
    return text.replace(/{(\d+)}/g, (match, index) =>
      typeof args[index] !== 'undefined' ? args[index] : match
    );
  }

  public translateInstantWithArgs(key: string, args: any[] = []): string {
    const translation = this.translate.instant(key);
    return this.formatString(translation, args);
  }
}
